const l10n: I18NCookieSetLayerTextData = {
  confirmToast: {
    content: "NC rozważnie zarządza Twoimi prywatnymi danymi.<br>Korzystamy z plików cookies i innych technologii śledzących, aby poprawiać wydajność strony i zapewniać personalizowane reklamy. Pragniemy ciągle się rozwijać poprzez zapisywanie informacji związanych z użytkownikiem w celu analizy natężenia ruchu i statystyk odwiedzających.<br>Wybierając opcję „Zgódź się na wszystko”, zgadzasz się na zapisywanie na swoim urządzeniu plików cookie, a jeśli klikniesz na „Odrzuć wszystko”, zapisywane będą wyłącznie niezbędne pliki cookie.<br>W każdej chwili możesz sprawdzić szczegółowe informacje na ten temat w <a href='#'>Polityce plików cookie</a> i zmienić ustawienia zgody lub się z niej wycofać.",
    BtnApply: 'Zgódź się na wszystko',
    BtnDeny: 'Odrzuć wszystko',
    BtnApplyOptional: 'Opcjonalna zgoda',
    BtnSetting: 'Ustawienia',
  },
  "settingModal":{
    "msgSuccess": "",
    "titleLayer": "",
    "topDesc": "",
    "chkRequired": "",
    "chkOptional": "",
    "chkOptional2": "",
    "chkOptional3": "",
    "btnApply": "",
    "tabRequired": "",
    "tabOptional": "",
    "tabOptional2": "",
    "tabOptional3": "",
    "requiredDesc": "",
    "optionalDesc": "",
    "optional2Desc": "",
    "optional3Desc": "",
    "providerColum": "",
    "nameColum": "",
    "purposeColum": "",
    "dataColum": "",
    "typeColum": ""
  }
};
export default l10n;
